import React from "react";
import "./Talks.css";
import TalkCard from "../../components/talkCard/TalkCard";
import { talkSection } from "../../portfolio";
import { Fade } from "react-reveal";

export default function Talks() {
  if (!talkSection.talks || talkSection.talks.length === 0) return null;
  return (
    <div className="main" id="talks">
      <div className="talk-header">
        <Fade bottom duration={1000} distance="20px">
          <h1 className="talk-header-title">{talkSection.title}</h1>
          <p className="subTitle talk-header-subtitle">
            {talkSection.subtitle}
          </p>
        </Fade>
        <div className="talk-cards-div">
          {talkSection.talks.map((talk, i) => {
            return (
              <TalkCard
                key={i}
                talkDetails={{
                  title: talk.title,
                  subtitle: talk.subtitle,
                  slides_url: talk.slides_url,
                  event_url: talk.event_url,
                  image: talk.image,
                }}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
}
